<template>
  <v-card class="v-table-card" transition="slide-x-transition">
    <v-card-title>{{ title }}</v-card-title>
    <v-data-table
      :options.sync="options"
      :items-per-page="options.itemsPerPage"
      v-bind="$attrs"
    >
      <template
        v-for="slot in Object.keys($scopedSlots)"
        :slot="slot"
        slot-scope="scope"
        ><slot :name="slot" v-bind="scope"
      /></template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top v-for="action in actions" :key="action.icon">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="() => action.action(item)"
              style="margin-right: 7px"
              v-show="actions"
              color="primary"
              v-bind="attrs"
              v-on="on"
              >{{ action.icon }}</v-icon
            >
          </template>
          <span>{{ action.text }}</span>
        </v-tooltip>

        <v-icon
          style="margin-right: 7px"
          color="primary"
          v-show="editClick"
          @click="() => editClick(item)"
          >fa-regular fa-pen-to-square</v-icon
        >

        <v-icon
          style="margin-right: 7px"
          color="primary"
          v-show="removeClick"
          @click="() => removeClick(item)"
          >fa-regular fa-trash-can</v-icon
        >

        <v-icon
          style="margin-right: 7px"
          color="primary"
          v-show="detailsClick"
          @click="() => detailsClick(item)"
          >fa-regular fa-eye</v-icon
        >

        <v-icon
          style="margin-right: 7px"
          color="primary"
          v-show="copyClick"
          @click="() => copyClick(item)"
          >fa-regular fa-clone</v-icon
        >
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: "p-server-data-table",

  data() {
    return {
      options: {
        itemsPerPage: 10,
      },
    };
  },

  props: [
    "title",
    "optionsHandler",
    "editClick",
    "removeClick",
    "detailsClick",
    "copyClick",
    "actions",
  ],

  watch: {
    options: {
      handler() {
        this.optionsHandler(this.options);
        this.$emit("options-change", this.options);
      },
      deep: true,
    },
  },
};
</script>

<style>
@import "./styles.css";
</style>
